// Conflict between eslint and prettier.  Remove the the line above to view the errors;
import React, { FC, memo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { createUseStyles } from "react-jss";
import Icon from "Components/Icons";
import TrailsList from "Containers/TrailsList";
import { setShowSearchOptions } from "Containers/CampusMap";
import { areEqual, areEqualShallow } from "Utils/areEqual";
import { setCurrentView } from "Containers/MapSwitcher/mapSwitcher.Actions";
import styles from "./styles";
import SearchOptionsTrails from "./SearchOptionsTrails";

interface Props {
  setTrails: (val: any) => void;
  setSearchOptionsView: (view: string) => void;
  showSwitcher: boolean;
  selectedTrails: number;
  setSelectedTrails: (trails: number) => void;
  showDefaultMobileSearchOptions: boolean;
  setShowDefaultMobileSearchOptions: (status: boolean) => void;
  selectedTrail: string;
  setSelectedTrail: (trail: string) => void;
  showTrails: boolean;
  setShowTrails: (showTrails: boolean) => void;
}

const Trails: FC<Props> = memo(
  ({
    setTrails,
    setSearchOptionsView,
    selectedTrails,
    setSelectedTrails,
    showDefaultMobileSearchOptions,
    setShowDefaultMobileSearchOptions,
    selectedTrail,
    setSelectedTrail,
    showTrails,
    setShowTrails,
    showSwitcher,
  }: Props) => {
    const useStyles = createUseStyles(styles);
    const classes = useStyles({ showTrails });
    const dispatch = useDispatch();
    const [hideHeight, setHideHeight] = useState(false);
    const { showDestinations } = useSelector(
      (selectors: any) => selectors.destinations,
      areEqual
    );
    const usedSwitcher = useSelector(
      (store: any) => store.mapSwitcher.usedSwitcher
    );
    const view = useSelector((store: any) => store.searchOptionsView.view);

    const resetTrails = () => {
      setSelectedTrails(-1);
      setSelectedTrail("");
    };

    const gotToDestinations = () => {
      resetTrails();
      setShowTrails(true);
      setSearchOptionsView("destinations");
      if (showDestinations) {
        dispatch(setShowSearchOptions(true));
      } else {
        dispatch(setShowSearchOptions(false));
      }
    };

    const goToCampusMap = () => {
      dispatch(setCurrentView("campusmap", false));
      resetTrails();
      // setShowTrails(true);
      setSearchOptionsView("destinations");
      dispatch(setShowSearchOptions(false));
    };

    const trailsAnimations = {
      open: {
        x: "0%",
        transition: {
          ease: [0.28, 0.57, 0.2, 1],
          duration: 0.5,
          onComplete: () => {
            setHideHeight(false);
          },
        },
      },
      closed: {
        x: "-100%",
        transition: {
          ease: "easeIn",
          duration: 0.25,
          onComplete: () => {
            setHideHeight(true);
          },
        },
      },
    };

    return (
      view === "trails" && (
        <div
          style={{ height: hideHeight ? "0" : "auto" }}
          className={`trails-test-class ${classes.container}}`}
        >
          <div
            className={`${classes.searchOptionsContainer} ${
              showTrails ? "" : classes.mobileWide
            }`}
          >
            <SearchOptionsTrails
              resetTrails={resetTrails}
              goToDestinations={gotToDestinations}
              goToCampusMap={goToCampusMap}
              usedSwitcher={usedSwitcher}
              showSwitcher={showSwitcher}
              setShowTrails={setShowTrails}
              showTrails={showTrails}
              setSearchOptionsView={setSearchOptionsView}
              showDefaultMobileSearchOptions={showDefaultMobileSearchOptions}
              setShowDefaultMobileSearchOptions={
                setShowDefaultMobileSearchOptions
              }
              selectedTrail={selectedTrail}
            />
            {!showTrails && (
              <>
                <div className={classes.onlyMobileLandscape}>
                  <Icon
                    type="leftarrow"
                    events={{
                      onClick: () => {
                        setShowTrails(true);
                      },
                    }}
                  />
                </div>
                <div className={classes.closeContainer}>
                  <Icon
                    type="close"
                    events={{
                      onClick: gotToDestinations,
                    }}
                  />
                </div>
              </>
            )}
          </div>
          <motion.div
            initial={{ x: "-100%" }}
            animate={showTrails ? "open" : "closed"}
            variants={trailsAnimations}
            className={classes.bottomContainer}
          >
            <div className={classes.spacer} />
            <div className={classes.trailsHolder}>
              {showTrails && (
                <TrailsList
                  setTrails={setTrails}
                  setShowTrails={setShowTrails}
                  showTrails={showTrails}
                  selectedTrails={selectedTrails}
                  setSelectedTrails={setSelectedTrails}
                  showDefaultMobileSearchOptions={
                    showDefaultMobileSearchOptions
                  }
                  setShowDefaultMobileSearchOptions={
                    setShowDefaultMobileSearchOptions
                  }
                  selectedTrail={selectedTrail}
                  setSelectedTrail={setSelectedTrail}
                />
              )}
            </div>
          </motion.div>
        </div>
      )
    );
  },
  areEqualShallow
);

export default Trails;
try {
    // @ts-ignore
    Trails.displayName = "Trails";
    // @ts-ignore
    Trails.__docgenInfo = { "description": "", "displayName": "Trails", "props": { "setTrails": { "defaultValue": null, "description": "", "name": "setTrails", "required": true, "type": { "name": "(val: any) => void" } }, "setSearchOptionsView": { "defaultValue": null, "description": "", "name": "setSearchOptionsView", "required": true, "type": { "name": "(view: string) => void" } }, "showSwitcher": { "defaultValue": null, "description": "", "name": "showSwitcher", "required": true, "type": { "name": "boolean" } }, "selectedTrails": { "defaultValue": null, "description": "", "name": "selectedTrails", "required": true, "type": { "name": "number" } }, "setSelectedTrails": { "defaultValue": null, "description": "", "name": "setSelectedTrails", "required": true, "type": { "name": "(trails: number) => void" } }, "showDefaultMobileSearchOptions": { "defaultValue": null, "description": "", "name": "showDefaultMobileSearchOptions", "required": true, "type": { "name": "boolean" } }, "setShowDefaultMobileSearchOptions": { "defaultValue": null, "description": "", "name": "setShowDefaultMobileSearchOptions", "required": true, "type": { "name": "(status: boolean) => void" } }, "selectedTrail": { "defaultValue": null, "description": "", "name": "selectedTrail", "required": true, "type": { "name": "string" } }, "setSelectedTrail": { "defaultValue": null, "description": "", "name": "setSelectedTrail", "required": true, "type": { "name": "(trail: string) => void" } }, "showTrails": { "defaultValue": null, "description": "", "name": "showTrails", "required": true, "type": { "name": "boolean" } }, "setShowTrails": { "defaultValue": null, "description": "", "name": "setShowTrails", "required": true, "type": { "name": "(showTrails: boolean) => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Trails/Trails.tsx#Trails"] = { docgenInfo: Trails.__docgenInfo, name: "Trails", path: "src/shared/components/Trails/Trails.tsx#Trails" };
}
catch (__react_docgen_typescript_loader_error) { }